var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatepickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_554_16135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.125 1.125V3H13.875V1.125C13.875 0.515625 14.3438 0 15 0C15.6094 0 16.125 0.515625 16.125 1.125V3H18C19.6406 3 21 4.35938 21 6V6.75V9V21C21 22.6875 19.6406 24 18 24H3C1.3125 24 0 22.6875 0 21V9V6.75V6C0 4.35938 1.3125 3 3 3H4.875V1.125C4.875 0.515625 5.34375 0 6 0C6.60938 0 7.125 0.515625 7.125 1.125ZM2.25 9V21C2.25 21.4219 2.57812 21.75 3 21.75H18C18.375 21.75 18.75 21.4219 18.75 21V9H2.25Z",
    fill: "#4D2B6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_554_16135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepickerIcon);
export default __webpack_public_path__ + "static/media/datepickerIcon.d97a0e11c28749669fb8035a15e75216.svg";
export { ForwardRef as ReactComponent };